export default "__VITE_ASSET__0f9901f4__"